//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { BTab, BTabs } from 'bootstrap-vue'
import ProfileData from '~/components/profile/mixins/ProfileData'
import ProfileMixinDestinations from "~/components/profile/mixins/ProfileMixinDestinations"
import ProfileOverviewLazy from "~/components/profile/mixins/ProfileOverviewLazy"

export default {

    name: 'ProfileDestinations',

    mixins: [ProfileData, ProfileOverviewLazy, ProfileMixinDestinations],

    components: { BTab, BTabs },

    props: {
        company: {
        },
    },

    data() {
        return {
        }
    },

    /*async fetch() {

        if(this.visible === false) {
            return
        }

        try {

            let resultMaster = false

            let resultDestinations = this.$store.dispatch('profile/GET_DESTINATIONS', this.company.id)
            let resultSelectData = this.$store.dispatch('profile/GET_CONTACT_SELECT_DATA', this.company.id)

            if(this.company.isMasterProfile) {
                resultMaster = this.$store.dispatch('profile/GET_MASTER_PROFILES', this.company.id)
            }

            let responseDestinations = await resultDestinations
            let responseSelectData = await resultSelectData

            if(resultMaster) {
                let responseMaster = await resultMaster
            }

            this.destinations = responseDestinations.data
            //this.contactSelectData = responseSelectData

            if(resultMaster) {
                this.masterProfiles = responseMaster.data
            }

        } catch (e) {
            this.$logger.captureException(e)
        }

        this.isReady = true

    },*/

    methods: {

    },

    computed: {

        /*showContent() {

            if(this.$fetchState.pending) {
                false
            }

            if(this.activeTab != 0) {
                return false
            }

            if(this.company.isMasterProfile) {
                return true
            }

            if(!this.destinations.length) {
                return false
            }

            return true

        },*/

        destinationTabLabel() {

            if(this.company.isMasterProfile) {
                return 'Members'
            } else {
                return 'Destinations'
            }
        },

        showOfficesTab() {

            if(this.company.hasDestinationContact && this.destinations.length > 1) {
                return true
            }

            if(this.company.hasDestinationOffices) {
                return true
            }

            return false

        },

    }

}

